import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'styled-components';

const StyledCircularProgress = styled(CircularProgress)``;

function CircleLoading() {
  return <StyledCircularProgress />;
}

export default CircleLoading;
